module.exports = __webpack_public_path__ + "static/images/lottery-bg.59a9ce5.png";